import { gql } from '@apollo/client';

const GET_RESOURCE_TYPE_CACHE_REDIRECT = gql`
  query ResourceTypeDetail($id: Int!) {
    resourceTypeDetail(id: $id) {
      title
    }
  }
`;

export default GET_RESOURCE_TYPE_CACHE_REDIRECT;
